
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ieTY5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraAutomationSettingsPage", () => $feb07078eedc1738$export$9f0de1aaf472742a);
$parcel$export(module.exports, "default", () => $feb07078eedc1738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("2Geeh");

var $47bDC = parcelRequire("47bDC");

var $i2Rm5 = parcelRequire("i2Rm5");

var $dAfqg = parcelRequire("dAfqg");

var $OxJd1 = parcelRequire("OxJd1");

var $9OXo1 = parcelRequire("9OXo1");

var $1bQGJ = parcelRequire("1bQGJ");

var $5Ix9D = parcelRequire("5Ix9D");
const $feb07078eedc1738$var$METRICS_PAGE_ID = 'project-settings-apps.jira-automation'; // eslint-disable-next-line jira/react/no-class-components
class $feb07078eedc1738$export$9f0de1aaf472742a extends (0, $5uXOq.Component) {
    render() {
        const { projectKey: projectKey } = this.props.match.params;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $OxJd1.ProjectSettingsController), {
            projectKey: projectKey
        }, this.renderContents());
    }
    constructor(...args){
        super(...args), this.renderContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
                id: $feb07078eedc1738$var$METRICS_PAGE_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
                        theme: {}
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ix9D.default), {
                        tenantContext: tenantContext,
                        projectContext: projectContext.data
                    }))))));
    }
}
var $feb07078eedc1738$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($feb07078eedc1738$export$9f0de1aaf472742a);

});
parcelRegister("OxJd1", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $3be22f45e427033f$export$9e38610dc1164d7d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $3mYHL = parcelRequire("3mYHL");

var $9NiTW = parcelRequire("9NiTW");

var $9OXo1 = parcelRequire("9OXo1");

var $7tQej = parcelRequire("7tQej");

var $lADEy = parcelRequire("lADEy");
const $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $3be22f45e427033f$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, children)));
const $3be22f45e427033f$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: packageId,
        teamName: teamName,
        packageName: packageName,
        sendToPrivacyUnsafeSplunk: true
    }, children))));
const $3be22f45e427033f$export$9e38610dc1164d7d = (0, $cSD7y.componentWithFG)('projectsettingscontroller_error_boundary', $3be22f45e427033f$export$6d6f90026f9508a7, $3be22f45e427033f$export$2164d5fb3f070c32);
const $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lADEy.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });

});
parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $7tQej = parcelRequire("7tQej");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("lADEy", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $3bad71e90d481a39$export$b6f3f3997ca8a783);

var $dxCvy = parcelRequire("dxCvy");

var $2YP9W = parcelRequire("2YP9W");
const $3bad71e90d481a39$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});


parcelRegister("5Ix9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $2666825ce409db17$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $9Shla = parcelRequire("9Shla");
var $2666825ce409db17$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $9Shla.default));

});
parcelRegister("9Shla", function(module, exports) {

$parcel$export(module.exports, "default", () => $234eb071001a473c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $drk9v = parcelRequire("drk9v");

var $c2D8L = parcelRequire("c2D8L");

var $kb4zh = parcelRequire("kb4zh");

var $Uj4ce = parcelRequire("Uj4ce");

var $63MBm = parcelRequire("63MBm");

var $huDMB = parcelRequire("huDMB");
const $234eb071001a473c$var$JiraAutomationAppWrapper = ({ tenantContext: tenantContext, projectContext: projectContext, intl: { formatMessage: formatMessage } })=>{
    const { enabled: isLegacyAutomationEnabled } = (0, $Uj4ce.useNavigationAutomationLegacyEnabledResource)().data || {};
    if (!projectContext || !tenantContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    const { projectId: projectId, projectKey: projectKey, projectType: projectType } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $63MBm.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: projectKey,
        gridLayout: "fluid"
    }, isLegacyAutomationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $huDMB.default).breadcrumb)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drk9v.default), {
        container: {
            id: projectId,
            key: projectKey,
            type: projectType
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drk9v.default), {
        container: {
            id: projectId,
            key: projectKey,
            type: projectType
        }
    }));
};
var $234eb071001a473c$export$2e2bcd8739ae039 = $234eb071001a473c$var$JiraAutomationAppWrapper;

});
parcelRegister("drk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c7e8d35da359c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aIZdc = parcelRequire("aIZdc");

var $4R6GH = parcelRequire("4R6GH");

var $9FUIO = parcelRequire("9FUIO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dZw8H = parcelRequire("dZw8H");

var $2tT7R = parcelRequire("2tT7R");

var $9OXo1 = parcelRequire("9OXo1");

var $7FRCI = parcelRequire("7FRCI");
const $c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME = 'automationManagerBootstrap.pack.js';
let $c8c7e8d35da359c5$var$isBootStrapBeenAppended = false;
const $c8c7e8d35da359c5$export$1d6aa6cfe656cb32 = (jiraEnvironment, isAutomationDevInstance)=>{
    if (isAutomationDevInstance) {
        if (jiraEnvironment === 'staging') return 'dev';
        if (jiraEnvironment === 'prod') return 'test';
    }
    return jiraEnvironment === 'staging' ? 'staging' : 'prod';
};
/**
 * https://developer.atlassian.com/platform/bifrost/config/custom-domain/#custom-domain:-stating-your-own-identity
 * For fedramp, we return **environment type** rather than the **environment** itself.
 * @param environment
 * @param isFedRampInstance
 * @returns
 */ const $c8c7e8d35da359c5$var$getBifrostEnvironment = (environment, isFedRampInstance = false)=>{
    let bifrostEnvironment;
    if (environment === 'staging') bifrostEnvironment = isFedRampInstance ? 'stg' : 'stg-east';
    else // it's empty for fedramp prod
    bifrostEnvironment = isFedRampInstance ? '' : 'prod-east';
    return bifrostEnvironment;
};
/**
 * Gets the correct Bifrost url suffix based on the perimeter
 */ const $c8c7e8d35da359c5$var$getBifrostUrlSuffix = (isFedRampInstance)=>isFedRampInstance ? 'frontend.cdn.atlassian-us-gov-mod.com' : 'frontend.public.atl-paas.net';
const $c8c7e8d35da359c5$var$getBifrostBaseUrl = (env, perimeter)=>{
    const isFedRampInstance = perimeter === 'FEDRAMP';
    const bifrostUrlPrefix = 'https://automation-frontend';
    const bifrostEnvironment = $c8c7e8d35da359c5$var$getBifrostEnvironment(env, isFedRampInstance);
    const bifrostUrlSuffix = $c8c7e8d35da359c5$var$getBifrostUrlSuffix(isFedRampInstance);
    return [
        bifrostUrlPrefix,
        bifrostEnvironment,
        bifrostUrlSuffix
    ]// remove empty strings
    .filter((str)=>str).join('.');
};
const $c8c7e8d35da359c5$export$4bfd551f705b2cb = (env, perimeter)=>{
    // Local dev source
    if (env === 'dev') return `https://localhost:8082/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
    return `${$c8c7e8d35da359c5$var$getBifrostBaseUrl(env, perimeter)}/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
};
const $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE = 'Sorry, something went wrong loading Automation. Please try again.';
const $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE = 'Are you running devWatch?';
const $c8c7e8d35da359c5$var$determineAutomationPerimeter = ()=>{
    if ((0, $aIZdc.isFedRamp)()) return 'FEDRAMP';
    return 'COMMERCIAL';
};
const $c8c7e8d35da359c5$var$AutomationAppComponent = ({ container: container })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const jiraEnvironment = (0, $2tT7R.useEnvironment)();
    const automationEnvironment = $c8c7e8d35da359c5$export$1d6aa6cfe656cb32(jiraEnvironment, (0, $4R6GH.fg)('automation-dev-helper'));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [bootStrapError, setBootStrapError] = (0, $5uXOq.useState)(null);
    const perimeter = (0, $5uXOq.useMemo)(()=>$c8c7e8d35da359c5$var$determineAutomationPerimeter(), []);
    (0, $5uXOq.useEffect)(()=>{
        if (performance) performance.mark('automation-host-product-start');
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c8c7e8d35da359c5$var$isBootStrapBeenAppended) {
            // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
            const script = document.createElement('script');
            const src = $c8c7e8d35da359c5$export$4bfd551f705b2cb(automationEnvironment, perimeter);
            const startTime = performance.now();
            script.src = src;
            script.async = true;
            script.onload = ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'loaded'
                }), 'automationBootstrapFile loaded', {
                    duration: duration,
                    automationEnvironment: automationEnvironment,
                    isUsingVersionedAssets: true
                });
            };
            script.onerror = async ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'failed'
                }), 'automationBootstrapFile failed', {
                    duration: duration,
                    automationEnvironment: automationEnvironment,
                    isUsingVersionedAssets: true
                });
                setBootStrapError(automationEnvironment === 'dev' ? $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE : $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE);
                throw new Error(`Failed to load automation boostrap for env ${automationEnvironment}, src was '${src}'`);
            };
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.appendChild(script);
            $c8c7e8d35da359c5$var$isBootStrapBeenAppended = true;
        }
    }, [
        automationEnvironment,
        createAnalyticsEvent,
        perimeter
    ]);
    // Lifecycle events automation application can respond to start the application, and destroy it.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.postMessage('automation-container-mounted');
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.postMessage('automation-container-unmounted');
        };
    }, []);
    if (bootStrapError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FRCI.default), {
        title: "Failed to load Automation",
        description: bootStrapError
    });
    const context = {
        activationId: activationId,
        cloudId: cloudId,
        scopeId: container?.id || 'GLOBAL',
        scopeKey: container?.key,
        scopeType: container?.type,
        productType: 'jira',
        env: automationEnvironment,
        staticPrefix: $c8c7e8d35da359c5$var$getBifrostBaseUrl(automationEnvironment, perimeter),
        perimeter: perimeter,
        isUsingVersionedAssets: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FUIO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "automation-container",
        "data-context": JSON.stringify(context),
        "data-testid": "automation.automation-app-container"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
const $c8c7e8d35da359c5$var$AutomationApp = ({ container: container })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8c7e8d35da359c5$var$AutomationAppComponent, {
        container: container
    });
var $c8c7e8d35da359c5$export$2e2bcd8739ae039 = $c8c7e8d35da359c5$var$AutomationApp;

});
parcelRegister("9FUIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1259b4dcb355d8f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener = (0, $kxZPA.lazy)(()=>(parcelRequire("k0qGN")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $1259b4dcb355d8f8$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener, null)));
var $1259b4dcb355d8f8$export$2e2bcd8739ae039 = $1259b4dcb355d8f8$export$9b28d5c0f56030a7;

});
parcelRegister("k0qGN", function(module, exports) {

let $e90882aee0c820d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e90882aee0c820d8$var$load("h2MrD"),
    $e90882aee0c820d8$var$load("bYT2S"),
    $e90882aee0c820d8$var$load("li0NF")
]).then(()=>parcelRequire('LS48m'));

});


parcelRegister("7FRCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e338e454c92b953e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");
const $e338e454c92b953e$var$BootstrapPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e338e454c92b953e$var$pageContainerStyles,
        testId: "automation.automation-platform-bootstrap-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e338e454c92b953e$var$contentContainerStyles
    }, props.children));
const $e338e454c92b953e$var$BootstrapError = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e338e454c92b953e$var$BootstrapPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        title: props.title
    }, props.description));
var $e338e454c92b953e$export$2e2bcd8739ae039 = $e338e454c92b953e$var$BootstrapError;
const $e338e454c92b953e$var$pageContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh'
});
const $e338e454c92b953e$var$contentContainerStyles = (0, $8CUq3.xcss)({
    justifyContent: 'center',
    width: '500px'
});

});


parcelRegister("Uj4ce", function(module, exports) {

$parcel$export(module.exports, "useNavigationAutomationLegacyEnabledResource", () => $c645a2088e7fdbff$export$ca7c07083e4556cd);

var $kJQXA = parcelRequire("kJQXA");

var $2YP9W = parcelRequire("2YP9W");
const $c645a2088e7fdbff$export$ca7c07083e4556cd = ()=>{
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource));
    return {
        data: data,
        loading: loading
    };
};

});

parcelRegister("63MBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $97cfc99e6031092f$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bJcWY = parcelRequire("bJcWY");
var $aZdfU = parcelRequire("aZdfU");

var $e0Brz = parcelRequire("e0Brz");

var $jS4lj = parcelRequire("jS4lj");

var $e0tCO = parcelRequire("e0tCO");

var $gEFwt = parcelRequire("gEFwt");

var $dAfqg = parcelRequire("dAfqg");
const $97cfc99e6031092f$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            baseUrl: "",
            projectKey: projectKey,
            // Use projectKey as fallback display name to solve issues with projectData being unmocked in tests, projectData should never be undefined in the actual app as we are in the context of a project seeing as projectKey is a required prop
            projectName: projectData ? projectData.projectName : projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0tCO.default), {
            baseUrl: "",
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $97cfc99e6031092f$export$2e2bcd8739ae039 = $97cfc99e6031092f$var$AppContainer;
const $97cfc99e6031092f$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJcWY.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97cfc99e6031092f$var$NormalWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _ca0qze3t _u5f31ejb _n3tdze3t _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $97cfc99e6031092f$var$FullHeightWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $97cfc99e6031092f$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1ejb _4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $97cfc99e6031092f$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephoW.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itnZ9.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$var$defaultGridSize = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$var$defaultGridSize * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$var$defaultGridSize * 5,
    cosy: $196a11a7b8c2fbef$var$defaultGridSize * 2,
    compact: $196a11a7b8c2fbef$var$defaultGridSize * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});


parcelRegister("e0tCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $67a65658db3ebd27$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $7Xr7M = parcelRequire("7Xr7M");
var $67a65658db3ebd27$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $7Xr7M.default));

});
parcelRegister("7Xr7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c779f1fa7b01b6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");

var $9zgyl = parcelRequire("9zgyl");
const $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3')) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            href: (0, $81ps3.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $9zgyl.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $14c779f1fa7b01b6$export$2e2bcd8739ae039 = $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb;

});
parcelRegister("9zgyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e487ef6161e77fc4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e487ef6161e77fc4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});




parcelRegister("huDMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa1a141fe516da1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa1a141fe516da1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    breadcrumb: {
        "id": "spa-apps.project-settings.jira-automation.breadcrumb",
        "defaultMessage": "Automation"
    }
});

});





//# sourceMappingURL=async-project-settings-jira-automation.18d9ad43.js.map
